import {Colors} from '../../constants/colors'
import {faFileContract} from "@fortawesome/free-solid-svg-icons";
import {useState} from "react";
import ReportModal from "./ReportModal";
import {CompanyCreditReportModel, CreditRiskClassification} from "../../redux/companyMonitorTypes";
import CompanyReportInfoCard from "./CompanyReportInfoCard";

interface Props {
  creditReport: CompanyCreditReportModel
}

const CompanyReportCreditReportCard = ({creditReport}: Props) => {
  const [reportModalVisible, setReportModalVisible] = useState(false)

  const renderRiskClassification = () => {
    let color = Colors.green

    switch (creditReport.creditRiskClassification) {
      case CreditRiskClassification.veryHigh:
        color = Colors.rubel_900
        break
      case CreditRiskClassification.high:
        color = 'orange'
        break
      case CreditRiskClassification.medium:
      case CreditRiskClassification.low:
      case CreditRiskClassification.veryLow:
        color = Colors.green
        break
    }

    return (
      <p>Credit risk classification: <span style={{color: color}}>{creditReport.creditRiskClassification}</span></p>
    )
  }

  const renderProbabilityOfDefault = () => {
    const probabilityOfDefaultPercent = creditReport.probabilityOfDefaultPercent

    return (
      <p>Probability of default (%): <span>
        {probabilityOfDefaultPercent?.toFixed(2) ?? '-'}
      </span></p>
    )
  }

  const renderTotalDebtBalance = () => {
    const totalDebtBalance = creditReport.totalDebtBalance

    if (totalDebtBalance === null || totalDebtBalance === undefined) {
      return <p>Total debt balance: <span>-</span></p>
    }

    return (
      <p>Total debt balance: <span style={{color: totalDebtBalance > 0 ? Colors.rubel_400 : undefined}}>
        {totalDebtBalance.toLocaleString('sv-SE', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
      </span></p>
    )
  }

  return (
    <>
      <CompanyReportInfoCard
        title='Company credit report'
        icon={faFileContract}
        onClick={() => setReportModalVisible(true)}
        sources={['CreditSafe']}>
        <p>Credit score: <span>{creditReport.creditScore ?? '-'}</span></p>
        {renderProbabilityOfDefault()}
        {renderRiskClassification()}
        {renderTotalDebtBalance()}
      </CompanyReportInfoCard>

      <ReportModal
        title='Company credit report'
        visible={reportModalVisible}
        reportContent={creditReport.report}
        onCloseClick={() => setReportModalVisible(false)}
      />
    </>
  )
}
export default CompanyReportCreditReportCard
